import React from 'react';
import { PhoneIcon, EmailIcon, WhatsAppIcon, UserIcon, HomeIcon, CalendarIcon, StarIcon } from '../Icons/Icons';
import LazyImage from '../LazyImage/LazyImage';
import './AgentCard.css';

function AgentCard({ agent }) {
  const handleContact = (type) => {
    console.log(`Contact agent via ${type}`);
  };

  const handleViewProfile = () => {
    if (window.navigateTo) {
      window.navigateTo('agent-profile');
    }
  };

  return (
    <div className="agent-card">
      <div className="agent-card-header">
        <h3>Contact Agent</h3>
      </div>

      <div className="agent-info" onClick={handleViewProfile} style={{ cursor: 'pointer' }}>
        <div className="agent-avatar">
          {agent.photo ? (
            <LazyImage
              src={agent.photo}
              alt={agent.name}
              aspectRatio="1/1"
            />
          ) : (
            <div className="agent-avatar-placeholder">
              {agent.name.charAt(0)}
            </div>
          )}
        </div>

        <div className="agent-details">
          <h4 className="agent-name">{agent.name}</h4>
          {agent.agency && (
            <p className="agent-agency">{agent.agency}</p>
          )}
          {agent.verified && (
            <span className="agent-verified">✓ Verified Agent</span>
          )}
        </div>
      </div>

      {agent.rating && (
        <div className="agent-rating">
          <div className="rating-stars">
            {[...Array(5)].map((_, index) => (
              <StarIcon
                key={index}
                size={14}
                color="#f59e0b"
                filled={index < Math.floor(agent.rating)}
              />
            ))}
          </div>
          <span className="rating-text">
            {agent.rating} ({agent.reviews} reviews)
          </span>
        </div>
      )}

      <div className="agent-stats">
        <div className="stat-item">
          <HomeIcon size={20} color="var(--color-primary)" />
          <div className="stat-content">
            <span className="stat-value">{agent.properties || 0}</span>
            <span className="stat-label">Properties</span>
          </div>
        </div>
        <div className="stat-item">
          <CalendarIcon size={20} color="var(--color-primary)" />
          <div className="stat-content">
            <span className="stat-value">{agent.experience || 0}+ years</span>
            <span className="stat-label">Experience</span>
          </div>
        </div>
      </div>

      <div className="agent-actions">
        <button className="agent-btn btn-view-profile" onClick={handleViewProfile}>
          <UserIcon size={18} />
          <span>View Profile</span>
        </button>

        <button className="agent-btn btn-primary" onClick={() => handleContact('call')}>
          <PhoneIcon size={18} />
          <span>Call Agent</span>
        </button>

        <button className="agent-btn btn-secondary" onClick={() => handleContact('email')}>
          <EmailIcon size={18} />
          <span>Email Agent</span>
        </button>

        <button className="agent-btn btn-whatsapp" onClick={() => handleContact('whatsapp')}>
          <WhatsAppIcon size={18} />
          <span>WhatsApp</span>
        </button>
      </div>

      {agent.phone && (
        <div className="agent-phone">
          <PhoneIcon size={18} color="var(--color-text-secondary)" />
          <span className="phone-number">{agent.phone}</span>
        </div>
      )}
    </div>
  );
}

export default AgentCard;
